import {
  useConnectBtnBybit,
  useConnectBtnClover,
  useConnectBtnCoin98,
  useConnectBtnTrust,
} from '@ankr.com/provider';
import { ConnectBtn } from 'modules/auth/components/ConnectBtn';
import { WalletIcon } from 'modules/auth/components/WalletIcon';
import { useTranslation } from 'modules/i18n';
import { useConnectBtnAdapter } from '../../hooks/useConnectBtnAdapter';
import { IConnectButtonProps } from '../../types';
import { translation } from './translation';

export function ConnectDetectedWallets({ isDisabled }: IConnectButtonProps) {
  const connectBybitProps = useConnectBtnBybit();
  const connectCloverProps = useConnectBtnClover();
  const connectCoin98Props = useConnectBtnCoin98();
  const connectTrustProps = useConnectBtnTrust();

  const bybitProps = useConnectBtnAdapter(connectBybitProps);
  const cloverProps = useConnectBtnAdapter(connectCloverProps);
  const coin98Props = useConnectBtnAdapter(connectCoin98Props);
  const trustProps = useConnectBtnAdapter(connectTrustProps);

  const { keys, t } = useTranslation(translation);

  return (
    <>
      {connectBybitProps.isInjected && (
        <ConnectBtn
          isDisabled={isDisabled || bybitProps.isDisabled}
          title={t(keys.bybitTitle)}
          iconSlot={<WalletIcon wallet={connectBybitProps.walletId} />}
          {...bybitProps}
        />
      )}
      {connectCloverProps.isInjected && (
        <ConnectBtn
          isDisabled={isDisabled || cloverProps.isDisabled}
          title={t(keys.cloverTitle)}
          iconSlot={<WalletIcon wallet={connectCloverProps.walletId} />}
          {...cloverProps}
        />
      )}
      {connectCoin98Props.isInjected && (
        <ConnectBtn
          isDisabled={isDisabled || coin98Props.isDisabled}
          title={t(keys.coin98Title)}
          iconSlot={<WalletIcon wallet={connectCoin98Props.walletId} />}
          {...coin98Props}
        />
      )}
      {connectTrustProps.isInjected && (
        <ConnectBtn
          isDisabled={isDisabled || trustProps.isDisabled}
          title={t(keys.trustTitle)}
          iconSlot={<WalletIcon wallet={connectTrustProps.walletId} />}
          {...trustProps}
        />
      )}
    </>
  );
}
